import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ControlsModule } from 'app/controls/controls.module';
import { GalleryModule } from 'app/gallery/gallery.module';
import { ImageSelectionDirectiveModule } from 'app/image-selection.directive';
import { MatModule } from 'core/material/mat.module';
import { TranslationModule } from 'core/translation/translation.module';
import { GalleryToolboxComponent
       } from './gallery-toolbox/gallery-toolbox.component';
import { ImageToolboxComponent } from './image-toolbox/image-toolbox.component';
import { LayoutToolboxComponent
       } from './layout-toolbox/layout-toolbox.component';
import { PreviewToolboxComponent
       } from './preview-toolbox/preview-toolbox.component';
import { ProductChooserToolboxComponent
       } from './product-chooser-toolbox/product-chooser-toolbox.component';
import { TextToolboxComponent } from './text-toolbox/text-toolbox.component';
import { ToolboxTriggerComponent
       } from './toolbox-trigger/toolbox-trigger.component';
import { ToolboxComponent } from './toolbox.component';

@NgModule({
  imports: [
    CommonModule,
    ControlsModule,
    MatModule,
    GalleryModule,
    FormsModule,
    ImageSelectionDirectiveModule,
    TranslationModule,
  ],
  declarations: [
    GalleryToolboxComponent,
    ImageToolboxComponent,
    LayoutToolboxComponent,
    ProductChooserToolboxComponent,
    TextToolboxComponent,
    ToolboxComponent,
    ToolboxTriggerComponent,
    PreviewToolboxComponent,
  ],
  exports: [
    GalleryToolboxComponent,
    ImageToolboxComponent,
    LayoutToolboxComponent,
    ProductChooserToolboxComponent,
    TextToolboxComponent,
    ToolboxTriggerComponent,
    PreviewToolboxComponent,
  ],
})
export class ToolboxesModule { }
